import React from 'react';
import PropTypes from 'prop-types';
import { Search } from 'virtues-bootstrap';

function HeaderSearchInput({ meta, input, className, ...props }) {
  return <Search {...props} {...input} className={className} meta={meta} />;
}

HeaderSearchInput.defaultProps = {
  className: null,
};

HeaderSearchInput.propTypes = {
  className: PropTypes.string,
  meta: PropTypes.shape({}).isRequired,
  input: PropTypes.shape({}).isRequired,
};

export default HeaderSearchInput;
